/**
 * @file Content
 */

import { createPopper } from '@popperjs/core';
import { gsap } from 'gsap';

/**
 * Content component
 */
const vContent = () => {
	const content = document.querySelector( '.v-content' );
	if ( ! content ) {
		return;
	}

	const copyLink        = content.querySelector( '.v-content__meta-social-link' );

	if ( copyLink ) {
		const copyTooltip     = content.querySelector( '.v-content__copy-tooltip' );
		const copyTooltipWrap = content.querySelector( '.v-content__copy-tooltip-wrap' );
		createPopper( copyLink, copyTooltipWrap, {
			placement: 'top',
			modifiers: [
				{ name: 'hide' },
				{
					name:    'flip',
					options: {
						padding: { top: 68 },
					},
				},
			],
		} );

		let animating = false;
		copyLink.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			if ( animating ) {
				return;
			}
			animating = true;
			navigator.clipboard.writeText( copyLink.dataset.link )
				.then( () => {
					const flip = copyTooltipWrap.dataset.popperPlacement === 'bottom' ? -1 : 1;
					gsap.timeline( {
						defaults: { ease: 'sine.out' },
						onComplete() {
							animating = false;
						},
					} )
						.fromTo( copyTooltip, { y: 4 * flip, opacity: 0 }, {
							y:        0,
							opacity:  1,
							duration: .5,
							ease:     'power1.out',
						} )
						.to( copyTooltip, {
							y:        -4 * flip,
							opacity:  0,
							duration: .25,
						} );
				} )
				.catch( () => animating = false );
		} );
	}
};

export default vContent;
